module.exports = __webpack_public_path__ + "static/media/double-cheese.fbdefa2f.jpg";